import React from "react";
import styled, { css } from "styled-components";
import { darken } from "polished";

import { Text } from "../Text";

interface IconDropdownOptionProps {
  /** display value for the option */
  label: string;
  /** icon to display */
  icon?: React.ReactElement;
  /** onclick handler */
  onClick: () => void
}

const IconDropdownOption: React.FC<IconDropdownOptionProps> = ({
  label, icon, onClick
}) => {
  return (
    <StyledDropdownOption
      className='icon-dropdown-option'
      onClick={() => onClick()}
    >
      {icon}

      <Text className="icon-dropdown-label">
        {label}
      </Text>
    </StyledDropdownOption>
  );
};

export default IconDropdownOption;

const StyledDropdownOption = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: row;
    align-items: center;
    width: 200px;
    background: ${theme.colors.white};
    border: none;
    border-bottom: 2px solid ${theme.colors.lightGrey};
    position: relative;
    padding: 10px 10px;
    padding-right: 35px;
    max-height: 40px;
    transition: ${theme.transition.quickest};
    text-decoration: none;

    &:last-child {
      border-bottom: none;
    }

    &:hover,
    .active {
      cursor: pointer;
      background-color: ${darken(0.1, theme.colors.lightestGrey)};

      svg {
        fill: ${theme.colors.primaryDark};
      }
    }
    
    .icon-dropdown-label {
      margin-left: 10px;
    }
  `}
`;
